import React from 'react';
import toast from 'react-hot-toast';

import { DangerIcon } from '../../icons/DangerIcon';

export const failureToastView = (message) => {
  toast.custom((t) => (
    <div
      className={`${
        t.visible ? 'animate-enter' : 'animate-leave'
      } max-w-md w-full bg-red-50 shadow-lg rounded-lg pointer-events-auto flex px-6 py-4 mb-8	`}
      style={{
        boxShadow:
          '0 10px 10px -5px rgba(0, 0, 0, 0.04), 0 20px 25px -5px rgba(0, 0, 0, 0.1)'
      }}
    >
      <div className="flex-1 w-0">
        <div className="flex items-start">
          <div className="flex-shrink-0 pt-0.5">
            <DangerIcon />
          </div>
          <div className="ml-3 flex-1">
            <p className="text-base font-medium text-red-800">{message}</p>
          </div>
        </div>
      </div>
    </div>
  ));
};

export const customSuccessToast = (message) => {
  toast.custom((t) => (
    <div
      className={`${
        t.visible ? 'animate-enter' : 'animate-leave'
      } max-w-md w-full bg-green-50 shadow-lg rounded-lg pointer-events-auto flex px-6 py-4 mb-8	`}
      style={{
        boxShadow:
          '0 10px 10px -5px rgba(0, 0, 0, 0.04), 0 20px 25px -5px rgba(0, 0, 0, 0.1)'
      }}
    >
      <div className="flex-1 w-0">
        <div className="flex items-start">
          <div className="flex-shrink-0 pt-0.5"></div>
          <div className="ml-3 flex-1">
            <p className="text-base font-medium text-white">{message}</p>
          </div>
        </div>
      </div>
    </div>
  ));
};
